<template>
  <DragDialog
    title="用户列表"
    :width="800"
    :visible.sync="visible"
    :footerBtn="['cancel', 'submit']"
    :submit="submit"
    :cancel="cancel">
    <div class="searchFilter">
      <div class="search">
        <div class="filter-item-box">
          <div class="label-box dialog-label">用户名：</div>
          <div class="common-input-box">
            <el-input
              class="input-primary"
              size="small"
              v-model="userName"
              placeholder="请输入用户名称" />
          </div>
        </div>
        <div class="filter-item-box searchTable">
          <div class="label-box dialog-label">手机号：</div>
          <div class="common-input-box gr16">
            <el-input
              size="small"
              class="input-primary inputPhone"
              v-model="phone"
              placeholder="请输入手机号" />
          </div>
        </div>
      </div>

      <div class="opera">
        <div class="common-button-box btn-group-primary">
          <el-button
            size="small"
            class="primary-btn gr16"
            type="primary"
            @click="searchUser">
            查询
          </el-button>
          <el-button
            size="small"
            class="normal-btn"
            @click="resetFilter"
            >重置</el-button
          >
        </div>
      </div>
    </div>

    <div class="common-table-box">
      <el-table
      highlight-selection-row
        class="publish-small-table publish-table"
        :header-row-class-name="customHeader"
        ref="modelTable"
        :data="userList"
        height="100%"
        @select="selectChange"
        @select-all="selectChange">
        <el-table-column
          type="selection"
          width="60" />
        <el-table-column
          label="用户名"
          prop="userName" />
        <el-table-column
          label="手机号"
          prop="phone" />
        <template slot="empty">
          <div class="empty-box">
            <!-- :image="require('@/assets/img/no-data.png')" -->
            <bj-empty
              class="empty-page">
              <template>没有找到相关内容</template>
            </bj-empty>
          </div>
        </template>
      </el-table>
    </div>
  </DragDialog>
</template>

<script>
import DragDialog from '@/components/CustomDragDialog.vue'

export default {
  data() {
    return {
      userName: '',
      phone: '',
      selectUsers: [],
      customHeader: ''
    }
  },
  props: {
    visible: Boolean,
    userList: Array,
    search: Function,
    submitRequest: Function,
    closeDialog: Function
  },
  mounted() {
    setTimeout(() => {
      const currentBody = this.$refs.modelTable?.bodyWrapper
      currentBody &&
        currentBody.addEventListener('scroll', ev => {
          const scrollTop = ev.target.scrollTop
          this.customHeader = scrollTop > 10 ? 'darkHeader' : ''
        })
    }, 1500)
  },
  components: {
    DragDialog
  },
  methods: {
    searchUser() {
      this.search(this.userName, this.phone)
    },
    resetFilter() {
      this.userName = ''
      this.phone = ''
    },
    selectChange(users) {
      this.selectUsers = users
    },
    handleUserListScroll() {},
    submit() {
      if (!this.selectUsers.length) {
        this.$message.warning('请选择需要添加的用户')
        return
      }

      let userIds = this.selectUsers.map(el => el.userId)
      this.submitRequest(userIds).then(() => {
        this.userName = ''
        this.phone = ''
        this.selectUsers = []
        this.closeDialog()
      })
    },
    cancel() {
      this.userName = ''
      this.phone = ''
      this.selectUsers = []
      this.closeDialog()
    }
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';
.searchFilter {
  display: flex;
  align-items: center;
  justify-content: flex-start;

  .filter-item-box {
    margin-top: 0;
  }

  .search {
    flex: 1;
    display: flex;
  }

  .opera {
    flex-basis: 136px;

    .common-button-box{
      display: flex;
    }
  }
}
.filter-item-box {
  display: flex;
  margin-top: 10px;
  align-items: center;
  flex: 1;

  &:first-child {
    margin-top: 0px;
  }

  &:not(:first-child) {
    .label-box {
      margin-left: 16px;
    }
  }

  .label-box {
    color: var(--form-label-text-color);
    text-align: right;
  }

  .common-input-box {
    flex-grow: 1;
  }
}

.searchTable {
  flex: 1;
}

.common-table-box {
  margin-top: 16px;
  height: 500px;
}
</style>
